import type { IntakePageDef } from "@/hooks/useIntakeForm";
import { IntakeSection } from "./IntakeSection";

type Props = {
  page: IntakePageDef;
  values: Record<string, unknown>;
  setFieldValue: (id: string, value: unknown) => void;
  errors: Record<string, string>;
  ageDays: number | null;
};

export function IntakePage({
  page,
  values,
  setFieldValue,
  errors,
  ageDays,
}: Props) {
  return (
    <div className="intake-page">
      <div className="complaint-history-heading mb-4">
        <div className="complaint-history-heading-bar" />
        <h2 className="complaint-history-heading-text text-lg sm:text-xl">{page.title}</h2>
      </div>
      {page.note && (
        <p className="mb-4 text-sm text-slate-500">{page.note}</p>
      )}
      {page.sections.map((sec) => (
        <IntakeSection
          key={sec.section_id}
          section={sec}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          ageDays={ageDays}
        />
      ))}
    </div>
  );
}
